import { useQuery } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";
import { medicalExaminationQueryKeys } from "./queryKeys";

export const useMedicalExaminationQuery = () => {
  return useQuery(medicalExaminationQueryKeys.categories(), () =>
    MedicalExaminationService.getCategories()
  );
};
